<template>
  <a-modal v-model:open="visible" :footer="null" :closable="false" :width="$store.getters.get_notMobileView ? '77%':'92%'">
    <div>
      <ul
        style="
          display: flex;
          justify-content: space-between;
          margin-bottom: 10px;
        "
      >
        <li style="cursor: pointer" @click="showModal">
          &lt;&lt; {{ $t('common.back') }}
        </li>
        <li>
          <a-button
            @click="chooseSiteConfirm"
            type="primary"
            style="background: #11254a; border-color: #11254a; cursor: pointer"
            >{{ $t('common.confirm') }}</a-button
          >
        </li>
      </ul>
      <!-- style="display: flex; justify-content: space-between" -->
      <ul class="chooseContentUl">
        <li
          style="
            flex: 0 0 49%;
            background: #bfe5b6;           
            height: 400px;
            padding: 8px;
          "
        >
        <!-- style="display: flex" -->
          <div class="searchBox">
             <!-- style="border: 0; flex: 0 0 120px; margin-right: 10px" -->
            <a-input
              v-model:value="StationInput"
              :placeholder="$t('component.SiteM.searchStation')"
             
            ></a-input>
            <!-- style="
                flex: 0 0 20%;
                height: 30px;
                background: #2ca70e;
                border-color: #2ca70e;
                margin-right: 10px;
              " -->
            <a-button
              @click="StationSearchAndChoose"
              type="primary"
              style="background: #2ca70e; border-color: #2ca70e;"
              >{{ $t('common.searchAndChoose') }}</a-button
            >
            <!-- style="
                flex: 0 0 20%;
                height: 30px;
                background: #2ca70e;
                border-color: #2ca70e;
              " -->
            <a-button
              @click="selectedStation('all')"
              type="primary"
              style="background: #2ca70e; border-color: #2ca70e;"
              :style="{ display: isSingleChoose == '1' ? 'none' : 'block' }"
              
              >{{ $t('common.chooseAll') }}</a-button
            >
          </div>
          <div class="leftContainer">
            <ul class="lineList" style="color: #3f8f2d">
              <li
                @click="select(line.id)"
                :class="line.isActive"
                v-for="line in MetroLines"
                :key="line.id"
              >
                {{ line.name }}
              </li>
            </ul>
            <div class="stationList" style="margin-left: 2px">
              <ul
                style="
                  display: flex;
                  padding: 10px;
                  flex-wrap: wrap;
                  color: #3f8f2d;
                "
              >
                <li
                  @click="selectedStation(s.id)"
                  :class="s.isActive"
                  v-for="s in MetroStations"
                  :key="s.id"
                >
                  {{ s.name }}
                </li>
              </ul>
            </div>
          </div>
        </li>
        <li
          style="
            flex: 0 0 49%;
            background: #c6d4f1;
            height: 400px;
            padding: 8px;            
          "
        >
        <!-- style="display: flex" -->
          <div class="searchBox">
            <!-- style="border: 0; flex: 0 0 120px; margin-right: 10px" -->
            <a-input
              v-model:value="MallInput"
              :placeholder="$t('component.SiteM.searchMall')"              
            >
            </a-input>
            <!-- style="
                flex: 0 0 20%;
                height: 30px;
                background: #395489;
                border-color: #395489;
                margin-right: 10px;
              " -->
            <a-button
              @click="MallSearchAndChoose"
              type="primary"
              style="background: #395489;border-color: #395489;"
              >{{ $t('common.searchAndChoose') }}</a-button
            >
             <!-- style="
                flex: 0 0 20%;
                height: 30px;
                background: #395489;
                border-color: #395489;
              " -->
            <a-button
              @click="selectedMall('all')"
              type="primary"
              style="background: #395489;border-color: #395489;"
              :style="{ display: isSingleChoose == '1' ? 'none' : 'block' }"
              >{{ $t('common.chooseAll') }}</a-button
            >
          </div>
          <!-- style="display: flex; height: 90%; margin-top: 8px" -->
          <div :class="[ isSingleChoose == '1' ? 'mallListBoxSingleBtn' : 'mallListBox' ]">
            <div class="MallList">
              <ul
                style="
                  display: flex;
                  padding: 10px;
                  flex-wrap: wrap;
                  color: #6a7ea8;
                "
              >
                <li
                  @click="selectedMall(m.id)"
                  :class="m.isActive"
                  v-for="m in Malls"
                  :key="m.id"
                >
                  {{ m.name }}
                </li>
              </ul>
            </div>
          </div>
        </li>
      </ul>
    </div>
  </a-modal>
</template>

<script>
export default {
  name: 'StationOrMallChoose',
  props: ['isSingleChoose'],
  data() {
    return {
      visible: false,
      MetroLines: '',
      MetroStations: '',
      Malls: '',
      StationInput: '',
      MallInput: '',
      SiteList: '',
      ShopM: '',
      isMoblieView:false
    };
  },
  methods: {
    showModal() {
      if (this.visible) this.visible = false;
      else this.visible = true;
    },
    dataChange(isInit) {
      let self = this;
      var shopCollection = JSON.parse(
        this.$store.getters.get_shop_collection_cache
      );

      // set initiate isActive property
      shopCollection.metroLines.forEach((line) => {
        line.isActive = '';
        line.metroStations.forEach((station) => {
          station.isActive = '';
        });
      });
      shopCollection.malls.forEach((mall) => {
        mall.isActive = '';
      });

      self.MetroLines = shopCollection.metroLines;
      if (isInit == '1') {
        if (self.MetroLines.length > 0) {
          self.MetroLines[0].isActive = 'selectedLine';
          self.MetroStations = self.MetroLines[0].metroStations;
        }
      }
      self.Malls = shopCollection.malls;
    },
    select(id) {
      this.MetroLines.forEach((line) => {
        if (line.id == id) {
          line.isActive = 'selectedLine';
          this.MetroStations = line.metroStations;
        } else {
          line.isActive = '';
        }
      });
    },
    selectedStation(id) {
      let isActive = this.MetroStations[0].isActive;
      this.MetroLines.forEach((line) => {
        line.metroStations.forEach((station) => {
          if (id == 'all') {
            if (!isActive) station.isActive = 'selectedStation';
            else station.isActive = '';
          } else {
            if (station.id == id) {
              if (station.isActive) station.isActive = '';
              else station.isActive = 'selectedStation';
            } else {
              if (this.isSingleChoose == '1') station.isActive = '';
            }
          }
        });
      });

      if (this.isSingleChoose == '1') {
        this.Malls.forEach((m) => {
          m.isActive = '';
        });
      }
    },
    selectedMall(id) {
      let isActive = this.Malls[0].isActive;
      this.Malls.forEach((m) => {
        if (id == 'all') {
          if (!isActive) m.isActive = 'selectedMall';
          else m.isActive = '';
        } else {
          if (m.id == id) {
            if (m.isActive) m.isActive = '';
            else m.isActive = 'selectedMall';
          } else {
            if (this.isSingleChoose == '1') m.isActive = '';
          }
        }
      });

      if (this.isSingleChoose == '1') {
        this.MetroLines.forEach((line) => {
          line.metroStations.forEach((station) => {
            station.isActive = '';
          });
        });
      }
    },
    StationSearchAndChoose() {
      if (!this.StationInput) {
        this.$message.info(this.$t('component.SiteM.searchStationCannotEmpty'));
        return;
      }

      let isChooseStationed = true;
      this.MetroStations.forEach((station) => {
        if (
          station.name.toLowerCase().indexOf(this.StationInput.toLowerCase()) >
            -1 &&
          isChooseStationed
        ) {
          isChooseStationed = false;
          station.isActive = 'selectedStation';
        } else if (this.isSingleChoose == '1') station.isActive = '';
      });

      if (this.isSingleChoose == '1' && !isChooseStationed) {
        this.Malls.forEach((m) => {
          m.isActive = '';
        });
      }
    },
    MallSearchAndChoose() {
      if (!this.MallInput) {
        this.$message.info(this.$t('component.SiteM.searchMallCannotEmpty'));
        return;
      }
      let isChooseMalled = true;
      this.Malls.forEach((m) => {
        if (
          this.MallInput &&
          m.name.toLowerCase().indexOf(this.MallInput.toLowerCase()) > -1 &&
          isChooseMalled
        ) {
          isChooseMalled = false;
          m.isActive = 'selectedMall';
        } else if (this.isSingleChoose == '1') m.isActive = '';
      });

      if (this.isSingleChoose == '1' && !isChooseMalled) {
        this.MetroLines.forEach((line) => {
          line.metroStations.forEach((station) => {
            station.isActive = '';
          });
        });
      }
    },
    chooseSiteConfirm() {
      let sites = [];
      this.MetroLines.forEach((line) => {
        line.metroStations.forEach((station) => {
          if (station.isActive && !sites.some((s) => s.id == station.id)) {
            sites.push(station);
          }
        });
      });
      this.Malls.forEach((m) => {
        if (m.isActive) {
          sites.push(m);
        }
      });
      this.SiteList = sites;
      this.visible = false;
      this.ShopM.resetSites(sites);
      this.$emit('chooseSiteConfirm', sites);
    },
    getViewMedia(){
      var x = window.matchMedia('(max-width: 420px)');
      console.log("x.matches=" + x.matches);
      if(x && x.matches){
         //this.isMoblieView =true;
         return true;
      }
      return  false;
    }
  },
  created() {
    this.dataChange('1');
  }
};
</script>

<style scoped>
.ant-modal-body {
  padding: 10px;
  font-size: 14px;
  line-height: 1.5;
  word-wrap: break-word;
}
.leftContainer {
  display: flex;
  height: 90%;
  margin-top: 8px;
}
.lineList {
  flex: 0 0 120px;
  overflow-y: auto;
}
.lineList li {
  padding: 10px;
  cursor: pointer;
}
.stationList,
.MallList {
  flex: 1;
  background: white;
  border-radius: 0px 4px 4px;
  overflow-y: auto;
}
.stationList li,
.MallList li {
  background: #edeef0;
  flex: 0 0 30%;
  height: 35px;
  margin: 5px;
  line-height: 32px;
  text-align: center;
  border-radius: 4px;
  cursor: pointer;
  white-space: nowrap;
  padding: 0px 7px;
}
.site-select-span {
  flex: 1;
  font-size: 25px;
  cursor: pointer;
  background: url('/Images/setting.png') no-repeat;
  background-position: right 30px bottom;
  background-size: 25%;
}
.selectedLine {
  background: white;
  color: #167500;
  font-weight: bold;
  border-radius: 4px 0px 0px 4px;
}
.selectedStation {
  background: #bfe4b6 !important;
}
.selectedMall {
  background: #a6bce3 !important;
}

::-webkit-scrollbar-thumb {
  /*滚动条里面小方块*/
  border-radius: 8px;
  /* -webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.2); */
  background: #edeef0;
}

::-webkit-scrollbar-track {
  /*滚动条里面轨道*/
  /* -webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.2); */
  border-radius: 8px;
  background: #c6cad1;
}

.chooseContentUl {
  display: flex;
  justify-content: space-between;
}

.searchBox {
  display: flex;
}
.searchBox input[type='text'] {
  border: 0;
  flex: 0 0 120px;
  margin-right: 10px;
}
.searchBox > button {
  flex: 0 0 20%;
  height: 30px;
  margin-right: 10px;
}
.mallListBox,.mallListBoxSingleBtn {
  display: flex;
  height: 90%;
  margin-top: 8px;
}

@media (max-width: 1240px) {
  .chooseContentUl {
    flex-direction: column;
  }
}

@media (max-width: 420px) {
  .searchBox {
    display: flex;
    flex-direction: column;
    align-items: inherit;
  }
  .searchBox input[type='text'] {
    flex: none;
    margin-bottom: 10px;
  }
  .searchBox > button {
    margin-bottom: 5px;
    margin-right: 0px;
  }
  .leftContainer {
    height: 74%;
    margin-bottom: 10px;
  }
  .mallListBox {
    height: 74%;
  }
  .mallListBoxSingleBtn{
     height: 80%;
  }

  .stationList li,
  .MallList li {
    margin: 5px 1px;
    padding: 0px 5px;
  }
}
</style>
